<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    @close="$router.replace('/data/cars')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="car"
      :rules="rules"
      ref="carForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="plate_number"
        label="Rendszám"
      >
        <el-input
          v-model="car.plate_number"
        />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="make"
            label="Márka"
          >
            <el-input
              v-model="car.make"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="model"
            label="Modell"
          >
            <el-input
              v-model="car.model"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="in_date"
            label="Bekerülés dátum"
          >
            <el-date-picker
              v-model="car.in_date"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="out_date"
            label="Kikerülés dátum"
          >
            <el-date-picker
              v-model="car.out_date"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/data/cars')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['type', 'carId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        car: {},
        rules: {
          plate_number: [
            { required: true, message: 'Rendszám megadása kötelező', trigger: 'change' }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Gépkocsi';
        } else if (this.type === 'update') {
          return 'Gépkocsi módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    methods: {
      async add() {
        this.$refs['carForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('car/create', this.car);
              } else if (this.type === 'update') {
                await this.$store.dispatch('car/update', this.car);
              }
              this.$store.dispatch('car/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/data/cars');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      }
    },
    async mounted() {
      this.loading = true;
      if (this.carId) {
        this.car = await this.$store.dispatch('car/fetch', this.carId);
      }
      this.loading = false;
    },
  };
</script>
